export class OrganisationRoutingConstants {
    static ORGANISATION_SETTINGS_ROUTE = "organisation-settings";
    static USERS_ROUTE = "users";
    static APPLICATION_ROUTE = "application";
    static DETAILS_ROUTE = "details";
    static NOTIFICATION_TEMPLATES_ROUTE = "notificationtemplates";
    static MODULES_ROUTE = "modules";
    static AFLA_PORTAL_MAP_SERVICE_ROUTE = "mapservices";
    static ORGANISATION_CONFIG_ROUTE = "organisations";
    static ORGANISATION_SMS_SETTINGS_ROUTE = "smssettings";
    static ORGANISATION_BACKUP_RESTORE_SETTINGS_ROUTE = "organisationbackupandrestore";
}
